webpackJsonp([65],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(10);
	
	__webpack_require__(8);
	
	__webpack_require__(13);
	
	__webpack_require__(19);
	
	__webpack_require__(12);
	
	__webpack_require__(3);
	
	__webpack_require__(9);
	
	__webpack_require__(22);
	
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	__webpack_require__(16);
	
	__webpack_require__(129);
	
	__webpack_require__(1);
	
	__webpack_require__(4);
	
	__webpack_require__(6);
	
	__webpack_require__(5);
	
	__webpack_require__(7);
	
	__webpack_require__(4);
	
	__webpack_require__(24);
	
	__webpack_require__(11);
	
	__webpack_require__(15);
	
	__webpack_require__(2);
	
	(function() {
	  var $agreement, $area1, $dl, $form1, $mobile1, $shi1, $ting1, $wei1, $yangtai1;
	  if ($('#design').length > 0) {
	    $form1 = $('#design');
	    $mobile1 = $form1.find('[name="mobile"]');
	    $area1 = $form1.find('[name="area"]');
	    $shi1 = $form1.find('[name="shi"]');
	    $ting1 = $form1.find('[name="ting"]');
	    $wei1 = $form1.find('[name="wei"]');
	    $yangtai1 = $form1.find('[name="yangtai"]');
	    $dl = $form1.find('[name="dl"]');
	    $agreement = $form1.find('[name = agreement]');
	    $form1.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            var ref, ref1;
	            if (((ref = res.msg) != null ? (ref1 = ref[0]) != null ? ref1.type : void 0 : void 0) === 'success') {
	              window._agl && window._agl.push([
	                'track', [
	                  'success', {
	                    t: 3
	                  }
	                ]
	              ]);
	              if ($dl.val()) {
	                swal({
	                  title: '您的信息已提交成功，请注意短信查收报价结果',
	                  allowOutsideClick: true
	                });
	              } else {
	                swal({
	                  customClass: 'alert-success',
	                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
	                  confirmButtonText: '返  回',
	                  confirmButtonColor: '#3b9bff',
	                  allowOutsideClick: true,
	                  html: true,
	                  timer: 1000000
	                });
	              }
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    if ($agreement.length) {
	      $agreement.rules('add', {
	        required: true,
	        messages: {
	          required: '请勾选已阅读并同意积木家的用户协议'
	        }
	      });
	    }
	    if ($area1.length) {
	      $area1.rules('add', {
	        required: true,
	        messages: {
	          required: '请输入房屋面积'
	        }
	      });
	    }
	    if ($shi1.length) {
	      $shi1.rules('add', {
	        required: true,
	        messages: {
	          required: '请选择您家卧室个数'
	        }
	      });
	    }
	    if ($ting1.length) {
	      $ting1.rules('add', {
	        required: true,
	        messages: {
	          required: '请输入您家客厅个数'
	        }
	      });
	    }
	    if ($wei1.length) {
	      $wei1.rules('add', {
	        required: true,
	        messages: {
	          required: '请选择您家卫生间个数'
	        }
	      });
	    }
	    if ($yangtai1.length) {
	      $yangtai1.rules('add', {
	        required: true,
	        messages: {
	          required: '请选择您家阳台个数'
	        }
	      });
	    }
	    if ($mobile1.length) {
	      return $mobile1.rules('add', {
	        required: true,
	        mobileNum: true,
	        messages: {
	          required: '请输入11位手机号码',
	          mobileNum: '请输入正确的手机号'
	        }
	      });
	    }
	  }
	})();
	
	(function() {
	  var $agreement, $area, $dl, $form, $mobile;
	  if ($('#footerbaojia').length > 0) {
	    $form = $('#footerbaojia');
	    $area = $form.find('[name="area"]');
	    $mobile = $form.find('[name="mobile"]');
	    $dl = $form.find('[name="dl"]');
	    $agreement = $form.find('[name = agreement]');
	    $form.validate({
	      errorPlacement: function(error, element) {
	        return swal({
	          title: error[0].innerHTML,
	          allowOutsideClick: false
	        });
	      },
	      submitHandler: function(form) {
	        var phoneNumber, userId;
	        phoneNumber = form.elements.mobile.value.trim();
	        userId = "MOBI" + phoneNumber;
	        $(form).ajaxSubmit({
	          dataType: 'json',
	          data: {
	            rnd: parseInt(Math.random() * 1e7, 10) + (new Date()).getTime()
	          },
	          error: function() {
	            return swal({
	              title: '对不起，出错了，请稍后重试！',
	              allowOutsideClick: true
	            });
	          },
	          success: function(res) {
	            var ref, ref1;
	            if (((ref = res.msg) != null ? (ref1 = ref[0]) != null ? ref1.type : void 0 : void 0) === 'success') {
	              window._agl && window._agl.push([
	                'track', [
	                  'success', {
	                    t: 3
	                  }
	                ]
	              ]);
	              if ($dl.val()) {
	                swal({
	                  title: '您的信息已提交成功，请注意短信查收报价结果!',
	                  allowOutsideClick: true
	                });
	              } else {
	                swal({
	                  customClass: 'alert-success',
	                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
	                  confirmButtonText: '返  回',
	                  confirmButtonColor: '#3b9bff',
	                  allowOutsideClick: true,
	                  html: true,
	                  timer: 1000000
	                });
	              }
	            }
	            if (res.msg[0].type === 'error') {
	              swal({
	                title: res.msg[0].info,
	                allowOutsideClick: true
	              });
	              return false;
	            }
	          }
	        });
	        return false;
	      }
	    });
	    if ($agreement.length) {
	      $agreement.rules('add', {
	        required: true,
	        messages: {
	          required: '请勾选已阅读并同意积木家的用户协议'
	        }
	      });
	    }
	    if ($area.length) {
	      $area.rules('add', {
	        required: true,
	        messages: {
	          required: '请输入装修面积'
	        }
	      });
	    }
	    if ($mobile.length) {
	      return $mobile.rules('add', {
	        required: true,
	        mobileNum: true,
	        messages: {
	          required: '请输入11位手机号码',
	          mobileNum: '请输入正确的手机号'
	        }
	      });
	    }
	  }
	})();
	
	(function() {
	  var $yuyuefix, $yuyuefix_close;
	  $yuyuefix = $('.yuyuefix');
	  $yuyuefix_close = $yuyuefix.find('.fix_close');
	  return $yuyuefix_close.on('click', function(evt) {
	    evt.preventDefault();
	    return $yuyuefix.animate({
	      bottom: -100
	    });
	  });
	})();


/***/ },

/***/ 129:
3

});


/** WEBPACK FOOTER **
 ** praise-index.d737ce491e72d009c1c7.js
 **/